import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'aas-plain-chip',
  templateUrl: './plain-chip.component.html',
  styleUrls: ['./plain-chip.component.scss']
})
export class PlainChipComponent implements OnInit {
  @Input() background: string;
  @Input() value: string;
  @Input() set hasWarning(value: string) {
    this.showWarning = (value == 'true')
  }
  public showWarning: boolean = false;

  constructor() { }

  ngOnInit() { }

  public classes() {
    return {
      'chip-warning': this.showWarning
    }
  }
}
